<template>
	<div class="d_i_b">
		<el-upload class="daoru_button" :action="API_ROOT+action" :name="name" :headers="headers" :data="{...datas}" :show-file-list="false"  :before-upload="before_upload" :on-success="on_success" :on-error="on_error">
			<slot>
			    <el-button type="primary" size="mini" icon="el-icon-upload2">{{title}}</el-button>
			</slot>
		</el-upload>
	    <el-button size="mini" v-if="download" @click="click_download">{{subTitle||title+'模板'}}</el-button>
	</div>
</template>
<script>
const config = require('../../vue.config');
export default {
	name: 'upload_import',
	data() {
		return {
			API_ROOT:process.env.API_ROOT,
			loading:null,
			headers:{
				[JSON.parse(sessionStorage.getItem('settings')).token_name]:sessionStorage.getItem('token')
			}
		}
	},
	props: {
		// 导入地址
		action: {
			type:String,
			default:''
		},
		// 模板下载地址
		download:{
			type:String,
			default:''
		},
		// 显示文字
		title:{
			type:String,
			default:''
		},
		// 显示文字(副标题)
		subTitle:{
			type:String,
			default:''
		},
		// 导入的key名
		name: {
			type:String,
			default:'file'
		},
		// 附加参数
		datas: {
			type:Object,
			default:()=>{}
		},

	},
	watch: {},
	mounted() {},
	methods: {
		before_upload(file){
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'var(--loading-mask, rgba(0, 0, 0, 0.7))'
			});
		},
		on_success(res,file){
			if (res.code==200) {
				this.$message.success('导入成功');
				this.$emit('change',res&&res.data);
			}else{
				this.$showError(res);
			}
			this.loading.close();
		},
		on_error(res){
			console.log(res);
			this.$message.error('接口错误');
			this.loading.close();
		},
		// 下载模板
		click_download(){
			let link = document.createElement("a");
			var url = config.download+'download/'+this.download;
			link.href = url;
			var suffix = this.download.split('.');
			link.download = (this.subTitle||this.title)+'.'+(suffix.length>0?suffix[suffix.length-1]:'xlsx');
			link.target = '_blank';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	}
}
</script>
<style lang="css">
.d_i_b{
	line-height: 1;
	display: inline-block;
}	
.daoru_button{
	display: inline-block;
}
.daoru_button .el-upload{
	margin-bottom: 0;
}
.el-button+.el-button,
.daoru_button+.el-button,
.daoru_button+.daoru_button,
.el-button+.daoru_button{
	margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/upload_import.vue